import {
  GET_VIDEO_CALL_SETUP,
  GET_VIDEO_CALL_SETUP_FAILED,
  GET_VIDEO_CALL_SETUP_SUCCESS,
  RESET_VIDEO_CALL_SETUP,
  UPDATE_VIDEO_CALL_SETUP,
  UPDATE_VIDEO_CALL_SETUP_FAILED,
  UPDATE_VIDEO_CALL_SETUP_SUCCESS,
} from "./actionTypes"

export const getVideoCallSetup = params => ({
  type: GET_VIDEO_CALL_SETUP,
  payload: params,
})

export const getVideoCallSetupSuccess = response => ({
  type: GET_VIDEO_CALL_SETUP_SUCCESS,
  payload: response,
})

export const getVideoCallSetupFailed = error => ({
  type: GET_VIDEO_CALL_SETUP_FAILED,
  payload: error,
})

export const resetVideoCallSetup = () => ({
  type: RESET_VIDEO_CALL_SETUP,
  payload: {},
})

export const updateVideoCallSetup = params => ({
  type: UPDATE_VIDEO_CALL_SETUP,
  payload: params,
})

export const updateVideoCallSetupSuccess = response => ({
  type: UPDATE_VIDEO_CALL_SETUP_SUCCESS,
  payload: response,
})

export const updateVideoCallSetupFailed = error => ({
  type: UPDATE_VIDEO_CALL_SETUP_FAILED,
  payload: error,
})
